import ImplicitAuthProvider from '../../ImplicitAuthProvider'

export default class AuthStoreModuleContainer {
  implicitAuthProvider: ImplicitAuthProvider

  constructor (implicitAuthProvider: ImplicitAuthProvider) {
    this.implicitAuthProvider = implicitAuthProvider
  }
}
